import React, { useEffect, useRef, useState } from "react";
import { useCart } from "../context/CartContext";

function loadBoard() {
  try { const b = JSON.parse(localStorage.getItem("aubone-board") || "[]"); return Array.isArray(b) ? b : []; } catch (e) { return []; }
}

export default function Game() {
  const { toast } = useCart();
  const canvasRef = useRef(null);
  const stickRef = useRef(null);
  const knobRef = useRef(null);
  const hudScoreRef = useRef(null);
  const hudTimeRef = useRef(null);
  const autoRideRef = useRef(null);
  const nameRef = useRef(null);
  const engineRef = useRef({});

  const [showStart, setShowStart] = useState(true);
  const [showEnd, setShowEnd] = useState(false);
  const [endInfo, setEndInfo] = useState({ title: "Final bell", text: "", reward: false });
  const [board, setBoard] = useState(loadBoard);
  const [finalScore, setFinalScore] = useState({ s: 0, sa: 0 });

  useEffect(() => {
    const cv = canvasRef.current, ctx = cv.getContext("2d");
    const W = 360, H = 600, GOAL_W = 130, REACH = 44;
    let state, raf, last, keys = {}, target = null, swingQueued = false, stick = { x: 0, y: 0, on: false };
    function reset() { state = { p: { x: W / 2, y: H * .72, vx: 0, vy: 0, dx: 0, dy: -1, swing: 0 }, ai: { x: W / 2, y: H * .28, vx: 0, vy: 0, dx: 0, dy: 1, swing: 0, cool: 0 }, ball: { x: W / 2, y: H / 2, vx: 0, vy: 0 }, s: 0, sa: 0, t: 60, running: false, flash: 0 }; }
    reset(); draw();
    function ride(h, tx, ty, speed, dt) { const dx = tx - h.x, dy = ty - h.y, d = Math.hypot(dx, dy); if (d > 2) { const ax = dx / d, ay = dy / d; h.vx += ax * speed * dt * 8; h.vy += ay * speed * dt * 8; } }
    function stepHorse(h, dt, max) { const sp = Math.hypot(h.vx, h.vy); if (sp > max) { h.vx *= max / sp; h.vy *= max / sp; } h.x += h.vx * dt; h.y += h.vy * dt; h.vx *= Math.pow(.02, dt); h.vy *= Math.pow(.02, dt); if (sp > 8) { h.dx = h.vx / sp; h.dy = h.vy / sp; } h.x = Math.max(18, Math.min(W - 18, h.x)); h.y = Math.max(30, Math.min(H - 30, h.y)); if (h.swing > 0) h.swing -= dt * 5; }
    function tryHit(h, aimx, aimy, power) { const b = state.ball; const d = Math.hypot(b.x - h.x, b.y - h.y); h.swing = 1; if (d <= REACH + 14) { const dx = aimx - b.x, dy = aimy - b.y, l = Math.hypot(dx, dy) || 1; b.vx = dx / l * power + h.vx * .3; b.vy = dy / l * power + h.vy * .3; return true; } return false; }
    function update(dt) {
      const s = state, p = s.p, a = s.ai, b = s.ball;
      let ix = 0, iy = 0;
      if (keys.ArrowLeft || keys.a) ix -= 1; if (keys.ArrowRight || keys.d) ix += 1; if (keys.ArrowUp || keys.w) iy -= 1; if (keys.ArrowDown || keys.s) iy += 1;
      if (stick.on && Math.hypot(stick.x, stick.y) > .15) { ix = stick.x; iy = stick.y; }
      if (ix || iy) { const l = Math.max(1, Math.hypot(ix, iy)); p.vx += ix / l * 1600 * dt; p.vy += iy / l * 1600 * dt; }
      else if (autoRideRef.current && autoRideRef.current.checked) { ride(p, b.x, b.y + 16, 210, dt); }
      else if (target) { ride(p, target.x, target.y, 200, dt); }
      stepHorse(p, dt, 220);
      if (swingQueued) { swingQueued = false; tryHit(p, W / 2, -20, 430); }
      a.cool -= dt;
      const toBall = Math.hypot(b.x - a.x, b.y - a.y);
      const gy = H + 10;
      if (toBall > REACH) { const bx = b.x, by = b.y - 20; ride(a, bx, by, 165, dt); }
      else if (a.cool <= 0) { const jitter = (Math.random() - .5) * 60; tryHit(a, W / 2 + jitter, gy, 340); a.cool = .9; }
      stepHorse(a, dt, 175);
      b.x += b.vx * dt; b.y += b.vy * dt; b.vx *= Math.pow(.35, dt); b.vy *= Math.pow(.35, dt);
      if (Math.abs(b.vx) < 2) b.vx = 0; if (Math.abs(b.vy) < 2) b.vy = 0;
      [p, a].forEach(h => { const dx = b.x - h.x, dy = b.y - h.y, d = Math.hypot(dx, dy); if (d < 22 && d > 0) { b.x = h.x + dx / d * 22; b.y = h.y + dy / d * 22; b.vx += dx / d * 60 + h.vx * .4; b.vy += dy / d * 60 + h.vy * .4; } });
      const inGoalX = b.x > W / 2 - GOAL_W / 2 && b.x < W / 2 + GOAL_W / 2;
      if (b.y < 8) { if (inGoalX) { s.s++; s.flash = 1; resetBall(); } else { b.y = 8; b.vy = -b.vy * .6; } }
      if (b.y > H - 8) { if (inGoalX) { s.sa++; s.flash = -1; resetBall(); } else { b.y = H - 8; b.vy = -b.vy * .6; } }
      if (b.x < 8) { b.x = 8; b.vx = -b.vx * .6; } if (b.x > W - 8) { b.x = W - 8; b.vx = -b.vx * .6; }
      if (s.flash) s.flash *= (1 - dt * 2); if (Math.abs(s.flash) < .05) s.flash = 0;
      s.t -= dt;
      if (hudScoreRef.current) hudScoreRef.current.textContent = `${s.s} – ${s.sa}`;
      if (hudTimeRef.current) hudTimeRef.current.textContent = `0:${String(Math.max(0, Math.ceil(s.t))).padStart(2, "0")}`;
      if (s.t <= 0) endGame();
    }
    function resetBall() { const b = state.ball; b.x = W / 2; b.y = H / 2; b.vx = 0; b.vy = 0; state.p.x = W / 2; state.p.y = H * .72; state.ai.x = W / 2; state.ai.y = H * .28; target = null; }
    function drawHorse(h, body, shirt) {
      ctx.save(); ctx.translate(h.x, h.y); ctx.rotate(Math.atan2(h.dy, h.dx) + Math.PI / 2);
      ctx.fillStyle = "rgba(0,0,0,.25)"; ctx.beginPath(); ctx.ellipse(2, 4, 13, 22, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = body; ctx.beginPath(); ctx.ellipse(0, 0, 12, 22, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(0, -24, 6, 9, 0, 0, Math.PI * 2); ctx.fill();
      const ang = h.swing > 0 ? -1.2 + (1 - h.swing) * 2.4 : 0.5;
      ctx.strokeStyle = "#C9944A"; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(8, 0); ctx.lineTo(8 + Math.cos(ang) * 34, Math.sin(ang) * 34); ctx.stroke();
      ctx.fillStyle = "#EFE7D6"; ctx.beginPath(); ctx.ellipse(8 + Math.cos(ang) * 34, Math.sin(ang) * 34, 6, 3, ang, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = shirt; ctx.beginPath(); ctx.arc(0, -2, 8, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(0, -2, 4, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    }
    function draw() {
      const s = state;
      ctx.fillStyle = "#1E5238"; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = "rgba(255,255,255,.04)"; for (let y = 0; y < H; y += 60) { if ((y / 60) % 2 === 0) ctx.fillRect(0, y, W, 60); }
      ctx.strokeStyle = "rgba(255,255,255,.55)"; ctx.lineWidth = 2; ctx.strokeRect(6, 6, W - 12, H - 12);
      ctx.beginPath(); ctx.moveTo(6, H / 2); ctx.lineTo(W - 6, H / 2); ctx.stroke();
      ctx.setLineDash([6, 8]); ctx.beginPath(); ctx.moveTo(6, H / 2 - 60); ctx.lineTo(W - 6, H / 2 - 60); ctx.moveTo(6, H / 2 + 60); ctx.lineTo(W - 6, H / 2 + 60); ctx.stroke(); ctx.setLineDash([]);
      [[8, "#C81DD8"], [H - 8, "#F4F1EA"]].forEach(([gy, c]) => { ctx.fillStyle = c; ctx.fillRect(W / 2 - GOAL_W / 2 - 4, gy - 6, 8, 12); ctx.fillRect(W / 2 + GOAL_W / 2 - 4, gy - 6, 8, 12); ctx.fillStyle = "rgba(255,255,255,.08)"; ctx.fillRect(W / 2 - GOAL_W / 2, gy - 6, GOAL_W, 12); });
      if (s.flash) { ctx.fillStyle = s.flash > 0 ? `rgba(200,29,216,${Math.abs(s.flash) * .35})` : `rgba(255,255,255,${Math.abs(s.flash) * .25})`; ctx.fillRect(0, 0, W, H); }
      if (target && s.running) { ctx.strokeStyle = "rgba(255,255,255,.35)"; ctx.beginPath(); ctx.arc(target.x, target.y, 8, 0, Math.PI * 2); ctx.stroke(); }
      drawHorse(s.ai, "#B98A5A", "#F4F1EA"); drawHorse(s.p, "#4A2E1A", "#C81DD8");
      const b = s.ball; ctx.fillStyle = "rgba(0,0,0,.3)"; ctx.beginPath(); ctx.arc(b.x + 2, b.y + 3, 7, 0, Math.PI * 2); ctx.fill(); ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(b.x, b.y, 7, 0, Math.PI * 2); ctx.fill();
    }
    function loop(ts) { if (!state.running) return; const dt = Math.min(.033, (ts - last) / 1000 || .016); last = ts; update(dt); draw(); raf = requestAnimationFrame(loop); }
    function start() { reset(); state.running = true; setShowStart(false); setShowEnd(false); last = performance.now(); raf = requestAnimationFrame(loop); }
    function endGame() {
      state.running = false; cancelAnimationFrame(raf); draw();
      const { s, sa } = state; const margin = s - sa;
      setEndInfo({
        title: margin > 0 ? "You won the chukka" : (margin < 0 ? "The rival took it" : "All square"),
        text: `Final score ${s} – ${sa}.` + (margin >= 2 ? " Won by two — that's a discount." : " Win by two goals to unlock the code."),
        reward: margin >= 2,
      });
      setFinalScore({ s, sa });
      setShowEnd(true);
    }
    const swing = () => { if (state.running) swingQueued = true; };
    engineRef.current = { start, swing };

    const onKeyDown = e => { if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", " "].includes(e.key) && state.running) e.preventDefault(); keys[e.key] = true; if (e.key === " ") swing(); };
    const onKeyUp = e => { keys[e.key] = false; };
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("keyup", onKeyUp);

    function pt(e) { const r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) * W / r.width, y: (e.clientY - r.top) * H / r.height }; }
    const stickEl = stickRef.current, knob = knobRef.current;
    function stickMove(e) { const r = stickEl.getBoundingClientRect(); let dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2); const m = r.width / 2 - 10, d = Math.hypot(dx, dy); if (d > m) { dx = dx / d * m; dy = dy / d * m; } stick.x = dx / m; stick.y = dy / m; knob.style.transform = `translate(${dx}px,${dy}px)`; }
    const onStickDown = e => { e.preventDefault(); stick.on = true; stickEl.setPointerCapture(e.pointerId); stickMove(e); };
    const onStickMove = e => { if (stick.on) stickMove(e); };
    const onStickUp = () => { stick.on = false; stick.x = stick.y = 0; knob.style.transform = ""; };
    stickEl.addEventListener("pointerdown", onStickDown);
    stickEl.addEventListener("pointermove", onStickMove);
    stickEl.addEventListener("pointerup", onStickUp);
    stickEl.addEventListener("pointercancel", onStickUp);

    let dragging = false;
    const onCvDown = e => { dragging = true; target = pt(e); cv.setPointerCapture(e.pointerId); };
    const onCvMove = e => { if (dragging) target = pt(e); };
    const onCvUp = () => { dragging = false; };
    cv.addEventListener("pointerdown", onCvDown);
    cv.addEventListener("pointermove", onCvMove);
    cv.addEventListener("pointerup", onCvUp);
    cv.addEventListener("pointercancel", onCvUp);

    return () => {
      state.running = false;
      cancelAnimationFrame(raf);
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("keyup", onKeyUp);
      stickEl.removeEventListener("pointerdown", onStickDown);
      stickEl.removeEventListener("pointermove", onStickMove);
      stickEl.removeEventListener("pointerup", onStickUp);
      stickEl.removeEventListener("pointercancel", onStickUp);
      cv.removeEventListener("pointerdown", onCvDown);
      cv.removeEventListener("pointermove", onCvMove);
      cv.removeEventListener("pointerup", onCvUp);
      cv.removeEventListener("pointercancel", onCvUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveScore = () => {
    const name = (nameRef.current.value || "Player").trim();
    const b = loadBoard();
    b.push({ name, s: finalScore.s, sa: finalScore.sa });
    b.sort((x, y) => (y.s - y.sa) - (x.s - x.sa) || y.s - x.s);
    const top = b.slice(0, 8);
    try { localStorage.setItem("aubone-board", JSON.stringify(top)); } catch (e) { /* noop */ }
    setBoard(top);
    toast("Saved to the board");
  };

  return (
    <section id="play">
      <div className="wrap">
        <div className="sec-head">
          <h2>Play a chukka</h2>
          <p>One minute on the clock. Ride to the ball, swing, and score past the rival. Beat the rival by two and take a discount code with you.</p>
        </div>
        <div className="game-grid">
          <div className="game-shell">
            <canvas ref={canvasRef} id="field" width="360" height="600" aria-label="Polo mini game" />
            <div className="hud"><span ref={hudScoreRef}>0 – 0</span><span ref={hudTimeRef}>1:00</span></div>
            <div className="stick" ref={stickRef} aria-label="Joystick"><div className="knob" ref={knobRef} /></div>
            <button className="swing-btn" aria-label="Swing mallet" onPointerDown={e => { e.preventDefault(); engineRef.current.swing && engineRef.current.swing(); }}>SWING</button>
            {showStart && (
              <div className="overlay">
                <div>
                  <h3>Throw-in</h3>
                  <p>Steer with the joystick in the corner (or arrow keys). Tap SWING when you're on the ball — it aims at the top goal for you.</p>
                  <button className="btn btn-primary" onClick={() => engineRef.current.start && engineRef.current.start()}>Start the chukka</button>
                  <label className="assist"><input type="checkbox" ref={autoRideRef} defaultChecked /> Auto-ride to the ball (just swing)</label>
                </div>
              </div>
            )}
            {showEnd && (
              <div className="overlay">
                <div>
                  <h3>{endInfo.title}</h3>
                  <p>{endInfo.text}</p>
                  {endInfo.reward && (
                    <div><div>Your code, good on any custom mallet:</div><div className="code">CHUKKA10</div></div>
                  )}
                  <div style={{ display: "flex", gap: ".5rem", justifyContent: "center", flexWrap: "wrap", marginTop: "1.25rem" }}>
                    <input className="text-in" ref={nameRef} placeholder="Your name for the board" maxLength="16" style={{ maxWidth: 220 }} />
                    <button className="btn btn-primary" onClick={saveScore}>Save score</button>
                    <button className="btn btn-ghost" style={{ color: "#fff" }} onClick={() => engineRef.current.start && engineRef.current.start()}>Play again</button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="game-side">
            <h3>How it plays</h3>
            <p>Your pony is the dark one at the bottom. The ball only moves when someone swings, so get close before you hit — a swing from more than a mallet's reach away does nothing.</p>
            <ul className="rules">
              <li>Move: the joystick in the bottom-left corner, or arrow keys / WASD. With auto-ride on, your pony chases the ball by itself and you only swing.</li>
              <li>Swing: the pink button, or the space bar. Every swing aims at the top goal.</li>
              <li>Win the chukka by two goals and you'll get 10% off a custom mallet.</li>
            </ul>
            <div className="board">
              <table>
                <thead><tr><th>Leaderboard</th><th>Score</th><th>Margin</th></tr></thead>
                <tbody>
                  {board.length === 0 ? (
                    <tr><td colSpan="3" style={{ color: "var(--muted)" }}>Nobody has played on this device yet. Be the first name here.</td></tr>
                  ) : board.map((r, i) => (
                    <tr key={i}><td>{r.name}</td><td>{r.s} – {r.sa}</td><td>{r.s - r.sa > 0 ? "+" : ""}{r.s - r.sa}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
